import { useState, useEffect } from 'react';
import Head from 'next/head';
import { GetStaticProps } from 'next';
import { getMetadataTags } from 'lib/utils/get-metadata-tags';
import Script from 'next/script';
import { embeddablesScript } from 'lib/embeddables-survey-script';
import { activeMiniSale } from 'lib/mini-sale/mini-sale';

export type ScreenProps = {
  goForward: (submitData?: null, type?: null, stepOverride?: number) => null;
  analyticsData?: Record<string, any>;
  quizName?: string;
  screenName?: string;
  productSku?: string;
  quizPromoCode?: string;
  pageHeader?: React.ReactNode;
  pageBodyText?: React.ReactNode;
  buttonTheme?: React.CSSProperties;
  buttonText?: React.ReactNode;
  everythingIsSafeText?: React.ReactNode;
  infoCardData?: {
    title: string;
    infoList: React.ReactNode[];
  };
  showWelcomeKit?: boolean;
  templateStyles?: any;
};

const EMBEDDABLES_ID = 'flow_gc16je28gba9744829h72afff';

const quizDescription = `Take a moment to answer a few questions, and we'll let you know how DS-01 could help you achieve your health goals.`;
const title = 'Seed • Is DS-01 Right For You?';

const Quiz = () => {
  const [miniSaleName, setMiniSaleName] = useState<string | null>(null);

  useEffect(() => {
    const name = activeMiniSale()?.name;
    if (name) setMiniSaleName(name);
  }, []);

  return (
    <>
      <Head>
        <title>{title}</title>
        {getMetadataTags({
          pageTitle: title,
          pageDescription: quizDescription,
          canonicalUrl: 'https://seed.com/is-ds01-right-for-you',
          imageUrl:
            'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1759784820/structured-data/og-ds-quiz.png',
          ogImageAlt: 'Is DS-01 Right For You?',
        })}
      </Head>
      <Script
        id='ds-quiz'
        strategy='afterInteractive'
        dangerouslySetInnerHTML={{ __html: embeddablesScript }}
      />
      <div>
        {/* @ts-ignore */}
        <savvy
          id={EMBEDDABLES_ID}
          {...(miniSaleName ? { minisale: miniSaleName } : {})}
        />
      </div>
    </>
  );
};

export default Quiz;

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      pageLayout: 'blank',
    },
  };
};
